import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgExpandAll = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <rect width={8} height={1.5} y={3} fill={_.color} rx={0.75} />
    <rect width={8} height={1.5} y={7} fill={_.color} rx={0.75} />
    <rect width={8} height={1.5} y={11} fill={_.color} rx={0.75} />
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M15.797 6.22c.27.293.27.767 0 1.06l-2.308 2.5a.655.655 0 0 1-.979 0l-2.307-2.5a.795.795 0 0 1 0-1.06.655.655 0 0 1 .979 0L13 8.19l1.818-1.97a.655.655 0 0 1 .98 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgExpandAll);
export default ForwardRef;
